import React from 'react';

const AboutMe = () => {

    return (
        <div>
            <h1>abt me</h1>
        </div>
    )
}

export default AboutMe